import _classCallCheck from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/regenerator/index.js";
import { Container } from "./Container";
import { generatedAttribute } from "./Utils/Constants";
import { getRandom } from "../Utils/NumberUtils";
import { itemFromSingleOrMultiple } from "../Utils/Utils";
function fetchError(statusCode) {
  console.error("tsParticles - Error ".concat(statusCode, " while retrieving config file"));
}
function getDataFromUrl(_x, _x2) {
  return _getDataFromUrl.apply(this, arguments);
}
function _getDataFromUrl() {
  _getDataFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(jsonUrl, index) {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = itemFromSingleOrMultiple(jsonUrl, index);
            if (url) {
              _context6.next = 3;
              break;
            }
            return _context6.abrupt("return");
          case 3:
            _context6.next = 5;
            return fetch(url);
          case 5:
            response = _context6.sent;
            if (!response.ok) {
              _context6.next = 8;
              break;
            }
            return _context6.abrupt("return", response.json());
          case 8:
            fetchError(response.status);
          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDataFromUrl.apply(this, arguments);
}
export var Loader = /*#__PURE__*/function () {
  function Loader(engine) {
    _classCallCheck(this, Loader);
    this._engine = engine;
  }
  _createClass(Loader, [{
    key: "load",
    value: function load(tagId, options, index) {
      var params = {
        index: index,
        remote: false
      };
      if (typeof tagId === "string") {
        params.tagId = tagId;
      } else {
        params.options = tagId;
      }
      if (typeof options === "number") {
        params.index = options;
      } else {
        params.options = options !== null && options !== void 0 ? options : params.options;
      }
      return this.loadOptions(params);
    }
  }, {
    key: "loadJSON",
    value: function () {
      var _loadJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tagId, jsonUrl, index) {
        var url, id;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof jsonUrl === "number" || jsonUrl === undefined) {
                  url = tagId;
                } else {
                  id = tagId;
                  url = jsonUrl;
                }
                return _context.abrupt("return", this.loadRemoteOptions({
                  tagId: id,
                  url: url,
                  index: index,
                  remote: true
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function loadJSON(_x3, _x4, _x5) {
        return _loadJSON.apply(this, arguments);
      }
      return loadJSON;
    }()
  }, {
    key: "loadOptions",
    value: function () {
      var _loadOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var _a, _b, _c, tagId, index, jsonUrl, remote, options, domContainer, currentOptions, dom, oldIndex, old, canvasEl, existingCanvases, newItem;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tagId = (_a = params.tagId) !== null && _a !== void 0 ? _a : "tsparticles".concat(Math.floor(getRandom() * 10000));
                index = params.index;
                jsonUrl = params.url;
                remote = params.remote;
                if (!remote) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 7;
                return getDataFromUrl(jsonUrl, index);
              case 7:
                _context2.t0 = _context2.sent;
                _context2.next = 11;
                break;
              case 10:
                _context2.t0 = params.options;
              case 11:
                options = _context2.t0;
                domContainer = (_b = params.element) !== null && _b !== void 0 ? _b : document.getElementById(tagId);
                if (!domContainer) {
                  domContainer = document.createElement("div");
                  domContainer.id = tagId;
                  (_c = document.querySelector("body")) === null || _c === void 0 ? void 0 : _c.append(domContainer);
                }
                currentOptions = itemFromSingleOrMultiple(options, index), dom = this._engine.dom(), oldIndex = dom.findIndex(function (v) {
                  return v.id === tagId;
                });
                if (oldIndex >= 0) {
                  old = this._engine.domItem(oldIndex);
                  if (old && !old.destroyed) {
                    old.destroy();
                    dom.splice(oldIndex, 1);
                  }
                }
                if (domContainer.tagName.toLowerCase() === "canvas") {
                  canvasEl = domContainer;
                  canvasEl.dataset[generatedAttribute] = "false";
                } else {
                  existingCanvases = domContainer.getElementsByTagName("canvas");
                  if (existingCanvases.length) {
                    canvasEl = existingCanvases[0];
                    canvasEl.dataset[generatedAttribute] = "false";
                  } else {
                    canvasEl = document.createElement("canvas");
                    canvasEl.dataset[generatedAttribute] = "true";
                    domContainer.appendChild(canvasEl);
                  }
                }
                if (!canvasEl.style.width) {
                  canvasEl.style.width = "100%";
                }
                if (!canvasEl.style.height) {
                  canvasEl.style.height = "100%";
                }
                newItem = new Container(this._engine, tagId, currentOptions);
                if (oldIndex >= 0) {
                  dom.splice(oldIndex, 0, newItem);
                } else {
                  dom.push(newItem);
                }
                newItem.canvas.loadCanvas(canvasEl);
                _context2.next = 24;
                return newItem.start();
              case 24:
                return _context2.abrupt("return", newItem);
              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function loadOptions(_x6) {
        return _loadOptions.apply(this, arguments);
      }
      return loadOptions;
    }()
  }, {
    key: "loadRemoteOptions",
    value: function () {
      var _loadRemoteOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.loadOptions(params));
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function loadRemoteOptions(_x7) {
        return _loadRemoteOptions.apply(this, arguments);
      }
      return loadRemoteOptions;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, domContainer, options, index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  index: index,
                  remote: false
                };
                if (typeof id === "string") {
                  params.tagId = id;
                } else {
                  params.element = id;
                }
                if (domContainer instanceof HTMLElement) {
                  params.element = domContainer;
                } else {
                  params.options = domContainer;
                }
                if (typeof options === "number") {
                  params.index = options;
                } else {
                  params.options = options !== null && options !== void 0 ? options : params.options;
                }
                return _context4.abrupt("return", this.loadOptions(params));
              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function set(_x8, _x9, _x10, _x11) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "setJSON",
    value: function () {
      var _setJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, domContainer, jsonUrl, index) {
        var url, newId, newIndex, element;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (id instanceof HTMLElement) {
                  element = id;
                  url = domContainer;
                  newIndex = jsonUrl;
                } else {
                  newId = id;
                  element = domContainer;
                  url = jsonUrl;
                  newIndex = index;
                }
                return _context5.abrupt("return", this.loadRemoteOptions({
                  tagId: newId,
                  url: url,
                  index: newIndex,
                  element: element,
                  remote: true
                }));
              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function setJSON(_x12, _x13, _x14, _x15) {
        return _setJSON.apply(this, arguments);
      }
      return setJSON;
    }()
  }]);
  return Loader;
}();